import {DatePicker, DatePickerProps, Form, FormControlProps } from "rsuite";
import { forwardRef } from "react";

type DateInputProps = FormControlProps & DatePickerProps;

const FormDatePicker = forwardRef<HTMLTextAreaElement>((props, ref) => (
  <DatePicker {...props} size="xs" className="ms-2" placement="topStart" oneTap />
));

export const DateFormInput = ({
  name,
  ...props
}: DateInputProps) => {

 return (
    <Form.Group controlId={name} className="d-flex align-items-center m-0 p-0">
    <Form.Control
        accepter={FormDatePicker}
        name={name}
        {...props}
      >
      </Form.Control>
     </Form.Group>
  );
};
